import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { Event } from '../event';
import { copy } from '../utils';
import { List } from '../list';
/**
 * Сущность, которая реализует лог событий отдельного топика
 *
 * @export
 * @class EventsLog
 */
export var EventsLog = /*#__PURE__*/function () {
  function EventsLog(opts) {
    _classCallCheck(this, EventsLog);
    /**
     * Имя топика
     *
     * @type {string}
     * @memberof EventsLog
     */
    _defineProperty(this, "topic", void 0);
    _defineProperty(this, "consumers", new Set());
    _defineProperty(this, "events", new List());
    _defineProperty(this, "defaultTtl", void 0);
    this.defaultTtl = opts.ttl;
    this.topic = opts.topic;
  }
  _createClass(EventsLog, [{
    key: "size",
    get: function get() {
      return this.events.size;
    }

    /**
     * Подписка на косьюмера на топик
     *
     * @param {IConsumer} consumer
     * @memberof EventsLog
     */
  }, {
    key: "subscribe",
    value: function subscribe(consumer) {
      this.consumers.add(consumer);
    }

    /**
     * Отписка консьюмера от топика
     *
     * @param {IConsumer} consumer
     * @memberof EventsLog
     */
  }, {
    key: "unsubscribe",
    value: function unsubscribe(consumer) {
      this.consumers.delete(consumer);
    }

    /**
     * Чтение событий из лога. Возвращает итератор, т.е.
     * позволяет читать асинхронно
     *
     * @param {number} [id] - id события, с которого нужно начинать чтение
     * @returns {IterableIterator<IEvent<unknown> | null>}
     * @memberof EventsLog
     */
  }, {
    key: "read",
    value: function read(id) {
      return this.iterateFrom(id);
    }

    /**
     * Добавляет событие в конец списка и оповещает все консьюмеры.
     *
     * @template T
     * @param {IProduceEvent<T extends Serializable>} produceEvent - данные события
     * @memberof EventsLog
     */
  }, {
    key: "produce",
    value: function produce(produceEvent) {
      var event = new Event({
        type: produceEvent.type,
        value: copy(produceEvent.value),
        ttl: produceEvent.ttl || this.defaultTtl
      });
      var _this$events$add = this.events.add(event),
        id = _this$events$add.id;
      event.id = id;
      this.notifyConsumers();
    }
  }, {
    key: "notifyConsumers",
    value: function notifyConsumers() {
      var _iterator = _createForOfIteratorHelper(this.consumers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var consumer = _step.value;
          consumer.notify();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "iterateFrom",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function iterateFrom(id) {
      var currentNode;
      return _regeneratorRuntime.wrap(function iterateFrom$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (id) {
              _context.next = 3;
              break;
            }
            return _context.delegateYield(this.iterateAllEventsList(), "t0", 2);
          case 2:
            return _context.abrupt("return");
          case 3:
            currentNode = this.events.getNode(id);
            if (currentNode) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", null);
          case 6:
            if (!(currentNode = currentNode.next())) {
              _context.next = 11;
              break;
            }
            _context.next = 9;
            return copy(currentNode.value);
          case 9:
            _context.next = 6;
            break;
          case 11:
            return _context.abrupt("return");
          case 12:
          case "end":
            return _context.stop();
        }
      }, iterateFrom, this);
    })
  }, {
    key: "iterateAllEventsList",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function iterateAllEventsList() {
      var _iterator2, _step2, node, value;
      return _regeneratorRuntime.wrap(function iterateAllEventsList$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _iterator2 = _createForOfIteratorHelper(this.events);
            _context2.prev = 1;
            _iterator2.s();
          case 3:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 12;
              break;
            }
            node = _step2.value;
            if (node) {
              _context2.next = 7;
              break;
            }
            return _context2.abrupt("return", null);
          case 7:
            value = node.value;
            _context2.next = 10;
            return copy(value);
          case 10:
            _context2.next = 3;
            break;
          case 12:
            _context2.next = 17;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            _iterator2.e(_context2.t0);
          case 17:
            _context2.prev = 17;
            _iterator2.f();
            return _context2.finish(17);
          case 20:
            return _context2.abrupt("return");
          case 21:
          case "end":
            return _context2.stop();
        }
      }, iterateAllEventsList, this, [[1, 14, 17, 20]]);
    })
  }]);
  return EventsLog;
}();